import { createAction } from '../../utils/reduxUtils';
import { IAsyncError } from '../../common';

interface Author {
  id: string;
  name: string;
}

export const followAuthor = {
  request: createAction('@followAuthor/FOLLOW_AUTHOR_REQUEST')<Author>,
  success: createAction('@followAuthor/FOLLOW_AUTHOR_SUCCESS')<string>,
  failure: createAction('@followAuthor/FOLLOW_AUTHOR_FAILURE')<IAsyncError>,
  cancel: createAction('@followAuthor/FOLLOW_AUTHOR_CANCEL')<void>,
};

export const unfollowAuthor = {
  request: createAction('@followAuthor/UNFOLLOW_AUTHOR_REQUEST')<Author>,
  success: createAction('@followAuthor/UNFOLLOW_AUTHOR_SUCCESS')<string>,
  failure: createAction('@followAuthor/UNFOLLOW_AUTHOR_FAILURE')<IAsyncError>,
};

export const fetchFolloweeIds = {
  request: createAction('@followAuthor/FETCH_FOLLOWEE_IDS_REQUEST')<{ force: boolean }>,
  success: createAction('@followAuthor/FETCH_FOLLOWEE_IDS_SUCCESS')<string[]>,
  failure: createAction('@followAuthor/FETCH_FOLLOWEE_IDS_FAILURE')<IAsyncError>,
  cancel: createAction('@followAuthor/FETCH_FOLLOWEE_IDS_CANCEL')<void>,
};
